import common from './api/common'
import fastLiveStreaming from './api/fastLiveStreaming'
import apiForOtherDomainName from './api/apiForOtherDomainName'
import courseManagement from './api/courseManagement'
import operationOverview from './api/operationOverview'
import im from './api/im'
import stateMachine from './api/stateMachine'
import dataBigScreen from './api/dataBigScreen'
import largeThirdScreenCharts from './api/largeThirdScreenCharts'
import catalogConfig from './api/catalogConfig'
import apiForMSC2 from './api/apiForMSC2'
import buildingManagement from './api/buildingManagement'
import classroomManagement from './api/classroomManagement'
import classroomInspectionTour from './api/classroomInspectionTour'
import inspectionHistory from './api/inspectionHistory'
import organizationalManagement from './api/organizationalManagement'
import personnelManagement from './api/personnelManagement'

export default {
  ...common,
  ...fastLiveStreaming,
  ...apiForOtherDomainName,
  ...courseManagement,
  ...operationOverview,
  ...im,
  ...stateMachine,
  ...dataBigScreen,
  ...largeThirdScreenCharts,
  ...catalogConfig,
  ...apiForMSC2,
  ...buildingManagement,
  ...classroomManagement,
  ...classroomInspectionTour,
  ...inspectionHistory,
  ...organizationalManagement,
  ...personnelManagement
}
